const {Backbone} = require('backboneAdapter');
import NavBarView from 'js/views/navbar.view';
import engagementsChartSimpleView from 'js/views/engagement-satisfaction.simpleview';
import EngagementsView from 'js/views/engagements.view';

    export default Backbone.Router.extend({
        routes: {
            "": "defaultRoute"
        },
        initialize: function () {
            console.info("Initializing Engagement Router");
            this.navbar = new NavBarView();
            this.engagementsView = new EngagementsView();
        },
        defaultRoute: function () {
            console.info("defaultRoute");
            engagementsChartSimpleView.init('.container', 'engagement');
        }
    });
